// extracted by mini-css-extract-plugin
module.exports = {"container":"ContextWithLink_container__AmWAg","link":"ContextWithLink_link__8CMt9","sending":"ContextWithLink_sending__k3XTJ"};